import axios from '../Backend';

export const getAllContactsList = async () => {
    try {
        const response = await axios.get(`/api/v2/contacts`);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/contactListReq/getAllContactsList :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const createContactList = async (contactListObject) => {
    try {
        if (!contactListObject.email) {
            contactListObject.email = undefined;
        }
        const response = await axios.post(`/api/v2/contacts`, contactListObject);
        return response.data;
    } catch (error) {
        console.log('axios/contactListReq/createContactList :: Error');
        console.log(JSON.stringify(error?.response?.data));
        return { error: error?.response?.data };
    }
}

export const editContactList = async (contactId, contactListObject) => {
    try {
        if (!contactListObject.email) {
            contactListObject.email = undefined;
        }
        const response = await axios.patch(`/api/v2/contacts/${contactId}`, contactListObject);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/contactListReq/editContactList :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const deleteContactList = async (contactId) => {
    try {
        const response = await axios.delete(`/api/v2/contacts/${contactId}`);
        const resData = response.data;
        return resData;
    } catch (e) {
        console.log('axios/contactListReq/deleteContactList :: Error')
        console.log(JSON.stringify(e?.response?.data))
    }
}

export const importContactsRequest = async (contactListObject) => {
    try {
        const response = await axios.post(`/api/v2/contacts/importcontacts`, contactListObject);
        return response.data;
    } catch (error) {
        console.log('axios/contactListReq/importContacts :: Error');
        console.log(JSON.stringify(error?.response?.data));
        return { error: error?.response?.data };
    }
}

export const exportContactsRequest = async () => {
    try {
        const response = await axios.get(`/api/v2/contacts/exportcontacts`,{ responseType: 'blob' });
        return response;
    } catch (error) {
        console.log('axios/contactListReq/exportContactsRequest :: Error');
        console.log(JSON.stringify(error?.response?.data));
        return { error: error?.response?.data };
    }
}